var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAdmRecords = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.185,
    height: 15.185,
    viewBox: "0 0 15.185 15.185",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.593,11.593A3.8,3.8,0,1,0,7.8,7.8,3.8,3.8,0,0,0,11.593,11.593Zm0,1.9C9.059,13.491,4,14.762,4,17.287v1.9H19.185v-1.9C19.185,14.762,14.127,13.491,11.593,13.491Z",
    transform: "translate(-4 -4)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdmRecords, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/admRecords.d47df252.svg";
export { ForwardRef as ReactComponent };